import { DateTime } from 'luxon';
import { BlockPreview } from '../pages/block/types';
import { BlockDomain, BlockLayout } from '@strength/domain';

export function getCycleStartEndDates(startDate: string, sortOrder: number) {
  const blockStartDate = DateTime.fromISO(startDate);
  if (!blockStartDate.isValid) {
    throw new Error('Invalid start date');
  }

  const cycleLengthInDays = BlockDomain.DEFAULT_CYCLE_LENGTH_IN_DAYS;
  const cycleStartDate = blockStartDate.plus({
    days: cycleLengthInDays * (sortOrder - 1),
  });
  return {
    startDate: cycleStartDate.toISODate(),
    endDate: cycleStartDate.plus({ days: cycleLengthInDays - 1 }).toISODate(),
  };
}

export function getCycleAndSession(
  block: BlockPreview,
  cycleSortOrder: number,
  sessionSortOrder: number,
  adjustedSessionSortOrder?: number,
) {
  const { startDate, endDate } = getCycleStartEndDates(
    block.startDate,
    cycleSortOrder,
  );
  return {
    session: {
      id: sessionSortOrder,
      // we'll need to figure out cycle and session names once we start allowing changing them
      // adjustedSessionSortOrder can be different when adding/removing athlete workouts
      name: `${block.sessionLabel} ${adjustedSessionSortOrder ?? sessionSortOrder}`,
      sortOrder: sessionSortOrder,
    },
    cycle: {
      id: cycleSortOrder,
      name: `${block.cycleLabel} ${cycleSortOrder}`,
      sortOrder: cycleSortOrder,
      startDate,
      endDate,
    },
  };
}

export function getSortedCyclesAndSessions({
  startDate,
  cycleLabel,
  sessionLabel,
  layout,
}: {
  startDate: string;
  cycleLabel: string;
  sessionLabel: string;
  layout: BlockLayout;
}) {
  return {
    sortedSessions: Array(layout[1])
      .fill(null)
      .map((_, index) => ({
        id: index + 1,
        name: `${sessionLabel} ${index + 1}`,
        sortOrder: index + 1,
      })),
    sortedCycles: Object.keys(layout).map((cycleNum) => {
      const cycleSortOrder = parseInt(cycleNum);
      const { startDate: cycleStartDate, endDate } = getCycleStartEndDates(
        startDate,
        cycleSortOrder,
      );
      return {
        id: cycleSortOrder,
        name: `${cycleLabel} ${cycleSortOrder}`,
        startDate: cycleStartDate,
        endDate,
      };
    }),
  };
}
